import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './AppRouter';
import ReactGA from 'react-ga4';
ReactGA.initialize('G-F3BDP1QD4M');

export default function App() {
    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    }, []);

    return (
        <BrowserRouter>
            <AppRouter/>
        </BrowserRouter>
    )
}